import React, { ReactElement } from "react";
// import HandIconSVG from "../assets/img/svg/hand.svg";

export default function MoreInfoBlock(): ReactElement {
  return (
    <section className="more-information">
      <div className="more-information__container container">
        <div className="more-information__box">
          <div className="more-information__icon">
            {/* <img
              src={HandIconSVG}
              alt="Hand Icon"
              className="more-information__icon-img"
            /> */}
          </div>
          <div
            className="more-information__descr"
            style={{ paddingLeft: 0, textAlign: "center" }}
          >
            <h3 className="more-information__title h3">
              For more information about Canterbury‑Bankstown’s residential and
              CBD city cleaning initiatives
            </h3>
            <div className="more-information__action">
              <a
                href="https://www.cbcity.nsw.gov.au/resident/waste-recycling/city-cleaning"
                className="more-information__action-btn button button_shadow_default button_size_medium"
                target="blank"
              >
                Visit our page here
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
